<template>
  <div class="AMonthSelector">
    <div class="inline" style="width: 80px;">
      <ANumberSelector
        v-model="val.year"
        :minNumber="year_min"
        :maxNumber="year_max"
        @change="handleChange"
      />
    </div>
    <div class="inline ml-default">년</div>
    <div class="inline ml-default" style="width: 60px;">
      <ANumberSelector
        v-model="val.month"
        :maxNumber="12"
        @change="handleChange"
      />
    </div>
    <div class="inline ml-default">월</div>
  </div>
</template>
<script>
export default {
  name: 'AMonthSelector',
  data() {
    return {
      val: {},
    }
  },
  props: {
    value: {
      type: Object,
      default: function() {
        return {
          year: (new Date()).getFullYear(),
          month: (new Date()).getMonth() + 1,
        }
      }
    },
    year_min: {
      type: Number,
      default: 2020,
    },
    year_max: {
      type: Number,
      default: (new Date()).getFullYear(),
    },
  },
  created() {
    this.val = this.value;
    this.$emit('input', this.val);
  },
  methods: {
    handleChange() {
      this.$emit('input', this.val);
    },
  },
}
</script>